// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1CMt6","newExpiryDate":"styles_newExpiryDate__2BtiK","footer":"styles_footer__3TldK"};